/**
 * @generated SignedSource<<8497725abeca19c3ef0ae9b85ec35359>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ConvertToDiscussionDialogIssueProperties$data = {
  readonly assignees: {
    readonly totalCount: number;
  };
  readonly comments: {
    readonly totalCount: number;
  };
  readonly milestone: {
    readonly __typename: "Milestone";
  } | null | undefined;
  readonly projectsV2: {
    readonly totalCount: number;
  };
  readonly reactions: {
    readonly totalCount: number;
  };
  readonly " $fragmentType": "ConvertToDiscussionDialogIssueProperties";
};
export type ConvertToDiscussionDialogIssueProperties$key = {
  readonly " $data"?: ConvertToDiscussionDialogIssueProperties$data;
  readonly " $fragmentSpreads": FragmentRefs<"ConvertToDiscussionDialogIssueProperties">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "totalCount",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ConvertToDiscussionDialogIssueProperties",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "IssueCommentConnection",
      "kind": "LinkedField",
      "name": "comments",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ReactionConnection",
      "kind": "LinkedField",
      "name": "reactions",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserConnection",
      "kind": "LinkedField",
      "name": "assignees",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectV2Connection",
      "kind": "LinkedField",
      "name": "projectsV2",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Milestone",
      "kind": "LinkedField",
      "name": "milestone",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Issue",
  "abstractKey": null
};
})();

(node as any).hash = "33400062c6b309cf593dbe042c91f91e";

export default node;
